import React from 'react';
import Icon from '../../../components/AppIcon';

const UserPositionCard = ({ position, totalParticipants }) => {
  if (!position) return null;

  const percentile = Math.round(((totalParticipants - position?.rank + 1) / totalParticipants) * 100);
  
  const getPercentileMessage = () => {
    if (percentile >= 90) return { text: 'Elite Performer! 🌟', color: 'text-yellow-500' };
    if (percentile >= 75) return { text: 'Top Tier! 🔥', color: 'text-orange-500' };
    if (percentile >= 50) return { text: 'Above Average! 💪', color: 'text-primary' };
    return { text: 'Keep Going! 👍', color: 'text-muted-foreground' };
  };

  const message = getPercentileMessage();

  return (
    <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 border-2 border-primary/30 rounded-lg p-4 md:p-6 shadow-lg">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Target" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-heading font-bold text-foreground">Your Position</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Rank */}
        <div className="bg-card rounded-lg p-4 text-center">
          <div className="flex items-center justify-center mb-2">
            <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center">
              <Icon name="Award" size={24} color="var(--color-primary)" />
            </div>
          </div>
          <p className="text-3xl font-bold text-foreground mb-1">#{position?.rank}</p>
          <p className="text-xs text-muted-foreground">Current Rank</p>
        </div>

        {/* Performance */}
        <div className="bg-card rounded-lg p-4 text-center">
          <div className="flex items-center justify-center mb-2">
            <div className="w-12 h-12 rounded-full bg-success/20 flex items-center justify-center">
              <Icon name="TrendingUp" size={24} color="var(--color-success)" />
            </div>
          </div>
          <p className="text-3xl font-bold text-foreground mb-1">{position?.primaryStat}</p>
          <p className="text-xs text-muted-foreground">{position?.primaryLabel}</p>
        </div>

        {/* Percentile */}
        <div className="bg-card rounded-lg p-4 text-center">
          <div className="flex items-center justify-center mb-2">
            <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center">
              <Icon name="BarChart3" size={24} color="var(--color-accent)" />
            </div>
          </div>
          <p className="text-3xl font-bold text-foreground mb-1">{percentile}%</p>
          <p className="text-xs text-muted-foreground">Top Percentile</p>
        </div>
      </div>
      {/* Motivational Message */}
      <div className="mt-4 bg-card rounded-lg p-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Icon name="Sparkles" size={20} color="var(--color-primary)" />
          <div>
            <p className={`font-semibold ${message?.color}`}>{message?.text}</p>
            <p className="text-xs text-muted-foreground">
              You're in the top {percentile}% of {totalParticipants} members
            </p>
          </div>
        </div>
        {position?.change === 'up' && (
          <div className="flex items-center gap-1 text-success">
            <Icon name="ArrowUp" size={16} />
            <span className="text-sm font-semibold">Rising</span>
          </div>
        )}
      </div>
      {/* Additional Stats */}
      <div className="mt-4 grid grid-cols-2 gap-3">
        <div className="bg-card rounded-lg p-3">
          <p className="text-xs text-muted-foreground mb-1">Secondary Stats</p>
          <p className="text-sm font-semibold text-foreground">{position?.secondaryStat}</p>
        </div>
        <div className="bg-card rounded-lg p-3">
          <p className="text-xs text-muted-foreground mb-1">Additional Info</p>
          <p className="text-sm font-semibold text-foreground">{position?.tertiaryStats}</p>
        </div>
      </div>
    </div>
  );
};

export default UserPositionCard;